export class CustomerOverview {
    public CustomerId: number;
    public CustomerName: string;
    public Email: string;
    public JobsiteCount: number;
    public RecordCount: number;
    public DealershipName: string;
    public Checked:boolean =false;
}

export class JobSiteType {
    public Id: number;
    public Title: string;
}
export class ReportStyle {
    public ReportId: number;
    public ReportName: string;
}

export class NewCustomer {
    public CustomerName: string;
    public PhoneNumber: string;
    public Email: string;
    public Address: string;
    public Logo: string;
    public ReportStyleId: number;
    public DealershipId: number;
    public CreatedByUserId: number = 0;
    public DealerGroupId: number;
    public QuoteReportStyleId: number;
    public HourlyLabourCost: number;
    public RopeReportStyleId:number;
    public WearReportStyleId:number;
    public ThermographyEnable:number;
    public IsRepairer:boolean;
    public customerReference:string;
    public WsreReportStyleId:number;
}

export class UpdateCustomer extends NewCustomer {
    public CustomerId: number;
}


export enum ReportRetrieveOptions {

    ConditionReport = 1,
    QuoteReport = 2,
    RopeReport=3,
    WearReport=4,
    WsreReport=5

}

export class CountryVM {
    public CountryCode: number;
    public CountryName: string;
 }


